import type React from "react";
import { Navigate, Outlet } from "react-router";

import { useUserContext } from "../hooks/useUserContext";

interface Props {
  allowedRoles?: string[];
}

const RouteRequireRole: React.FC<Props> = ({ allowedRoles }) => {
  const { user } = useUserContext();

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default RouteRequireRole;
